import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CustomerService } from 'src/app/services/customer.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-user-metrics',
  templateUrl: './user-metrics.component.html',
  styleUrls: ['./user-metrics.component.css'],
})
export class UserMetricsComponent implements OnInit {
  metricsList: any[] = [];

  // Sort mapping
  sortMap: any = {
    active_score: 'uas.activity_score',
    attractiveness_score: 'ua.score',
    age: 'age',
    total_yes: 'ua.total_yes',
    total_pass: 'ua.total_pass',
  };

  // State
  sortBy: string = 'attractiveness_score';
  sortDir: string = 'DESC';

  gender: string = 'A';
  genderOptions = [
    { value: 'A', label: 'All' },
    { value: 'F', label: 'Female' },
    { value: 'M', label: 'Male' },
  ];

  subscription_type: string = 'all';
  subscriptionOptions = [
    { value: 'all', label: 'All' },
    { value: 'paid', label: 'Paid' },
    { value: 'non_paid', label: 'Non Paid' },
  ];

  subscriptionPackage: string = 'all';
  subscriptionPackageOptions = [
    { value: 'all', label: 'All' },
    { value: '1-Week Membership', label: '1-Week Membership' },
    { value: '1-Month Membership', label: '1-Month Membership' },
    { value: '3-Month Membership', label: '3-Month Membership' },
    { value: '6-month membership', label: '6-Month Membership' },
    { value: '12-Month Membership', label: '12-Month Membership' },
  ];

  // Pagination
  p: number = 1;
  limit: number = 20;
  total: number = 0;

  loading: boolean = false;

  constructor(
    private customerService: CustomerService,
    private toastr: ToastrService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.getMetrics();
  }

  getMetrics() {
    this.loading = true;
    const payload = {
      sortBy: this.sortBy,
      sortDir: this.sortDir,
      gender: this.gender,
      subscription_type: this.subscription_type,
      subscriptionPackage: this.subscriptionPackage,
      page: this.p - 1, // Backend expects 0-indexed page
      limit: this.limit,
    };

    const token = localStorage.getItem('token');

    this.customerService.getUserMetrics(payload, token).subscribe(
      (res: any) => {
        this.loading = false;
        if (res && (res.status === 200 || res.success)) {
          // Handle new structure
          if (res.data && res.data.users) {
            this.metricsList = res.data.users;
            this.total = res.data.pagination ? res.data.pagination.total : 0;
          } else {
            // Fallback for safety/old structure if any
            this.metricsList = Array.isArray(res.data) ? res.data : [];
            this.total = this.metricsList.length;
          }
        } else {
          this.toastr.error(res.message || 'Failed to fetch metrics');
        }
      },
      (err) => {
        this.loading = false;
        console.error(err);
        this.toastr.error('Error fetching metrics');
      }
    );
  }

  onSort(columnKey: string) {
    if (this.sortBy === columnKey) {
      this.sortDir = this.sortDir === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.sortBy = columnKey;
      this.sortDir = 'DESC'; // Default to DESC for new column
    }
    this.getMetrics();
  }

  onGenderChange(event: any) {
    this.gender = event.target.value;
    this.p = 1; // Reset to first page
    this.getMetrics();
  }

  onSubscriptionChange(event: any) {
    this.subscription_type = event.target.value;
    this.p = 1; // Reset to first page
    this.getMetrics();
  }

  onSubscriptionPackageChange(event: any) {
    this.subscriptionPackage = event.target.value;
    this.p = 1; // Reset to first page
    this.getMetrics();
  }

  onExport() {
    this.loading = true;
    const payload = {
      sortBy: this.sortBy,
      sortDir: this.sortDir,
      gender: this.gender,
      subscription_type: this.subscription_type,
      subscriptionPackage: this.subscriptionPackage,
      page: this.p - 1,
      limit: this.limit,
      isExport: true,
    };

    const token = localStorage.getItem('token');

    this.customerService.getUserMetrics(payload, token).subscribe(
      (res: any) => {
        this.loading = false;
        const blob = new Blob([res], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'user_metrics.csv';
        a.click();
        window.URL.revokeObjectURL(url);
      },
      (err) => {
        this.loading = false;
        console.error(err);
        this.toastr.error('Error exporting metrics');
      }
    );
  }

  onPageChange(page: number) {
    this.p = page;
    this.getMetrics();
  }

  navigateToCustomerDetail(userId: any) {
    this.router.navigate([`/customer-detail/${userId}/approved`]);
  }
}
